import './Note.scss';

const Note = () => (
  <div className="note">
    <div className="note-inner">
      <p className="note-paragraph">
        이 프로젝트는 시연 목적으로 인터랙티브 디벨로퍼에 의해 개발되었습니다.
      </p>
    </div>
  </div>
);

export default Note;
